import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogRef } from '@angular/material/dialog';

import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { Share } from '@helper/share';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

interface IDialogData {
  shareUrl: string | undefined;
}

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
  imports: [ImageLoadingComponent, MatDialogClose, FocusRemoverDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareComponent {
  readonly imageSize = 25;

  private readonly data: IDialogData = inject(MAT_DIALOG_DATA);

  static open(dialog: MatDialog, shareUrl?: string): MatDialogRef<ShareComponent> {
    const data: IDialogData = { shareUrl };
    return dialog.open(ShareComponent, { width: '380px', height: '290px', data });
  }

  shareFacebook(): void {
    Share.openFacebookLink(this.data.shareUrl);
  }

  shareLine(): void {
    Share.openLineLink('', this.data.shareUrl);
  }
}
